module.exports = __webpack_public_path__ + "assets/img/store02.520612ca.png";